import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class InventoryReceivingItemService extends ApiService {
  namespace = "receivingInventoryItem";
  icon = "PalletizedBoxes";
  name = "Type";
  favicon = "BoxWithLabel";
  Width = 1400;
  DOMAIN = -50;
  action = "action";
  type = "type";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;

  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Type",
      icon: PrimeIcons.LIST,
    },
  ];
  constructor() {
    super("inventory-receiving-item");
  }
}
